import {
  Component, Input, Output, EventEmitter, ViewChild,
} from '@angular/core';

import { SearchInputComponent } from 'shared/search/search-input/search-input.component';
import { ReceiversAdvancedSearchComponent } from 'shared/receivers/receivers-advanced-search/receivers-advanced-search.component';


@Component({
  moduleId: module.id,
  selector: 'receivers-search',
  templateUrl: 'receivers-search.component.html',
  styleUrls: ['receivers-search.component.scss'],
})
export class ReceiversSearchComponent {

  placeholder: string = 'Search for a receiver by name or other information…';
  showAdvancedSearch: boolean = false;

  @Input() filters: Array<any>;
  @Input() hasAdvancedSearch: boolean = true;
  @Input() ghostValue: string;
  @Input() searchModel: { filters: Array<any> } | void;

  @Output() advancedSearchRun: EventEmitter<any> = new EventEmitter();
  @Output() advancedSearchCancel: EventEmitter<any> = new EventEmitter();
  @Output() searchValueChanged: EventEmitter<any> = new EventEmitter();
  @Output() clearSearchClick: EventEmitter<any> = new EventEmitter();
  @Output() filterRemove: EventEmitter<any> = new EventEmitter();

  @ViewChild(SearchInputComponent, {static: false})
  searchInput: SearchInputComponent | void;

  @ViewChild(ReceiversAdvancedSearchComponent, {static: false})
  advancedSearch: ReceiversAdvancedSearchComponent | void;


  /*******************************************
   * COMPONENT GETTERS
   *******************************************/

  get searchInputValue(): string {
    return this.searchInput && this.searchInput.searchTermValue;
  }

  get searchModelFilters(): Array<any> {
    return this.searchModel && this.searchModel.filters || [];
  }

  /*******************************************
  * COMPONENT PUBLIC METHODS
  *******************************************/

  public resetSearchValue(value: string) {
    if (this.searchInput instanceof SearchInputComponent) {
      this.searchInput.resetValue(value);
    }
  }

  /*******************************************
   * COMPONENT EVENT HANDLERS
   *******************************************/

   onAdvancedSearchClick() {
     this.showAdvancedSearch = !this.showAdvancedSearch;
   }

   onAdvancedSearchCancel() {
     this.advancedSearchCancel.emit();
   }

   onAdvancedSearchRun() {
     this.advancedSearchRun.emit();
   }

   onSearchValueChanged(event: any) {
     this.searchValueChanged.emit(event);
   }

   onClearSearchClick() {
     this.clearSearchClick.emit();
   }

   onFilterRemove(event: any) {
     this.filterRemove.emit(event);
   }
 }
